import React from 'react';
import classNames from 'classnames';

import './styles.css';

const StepSection = ({step, header, children, className}: any) => (
  <div className={classNames('StepSection', className)}>
    <div className="header">
      <div className="stepNumber">{step}</div>
      <div>{header}</div>
    </div>
    <div className="children">{children}</div>
  </div>
);

export default StepSection;
